// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/82bb6b73b40193b7dd72.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7549b30666f8237d1906","171":"30c37413bd5404326796","172":"7d9bbe00223ba1e23a2d"}[chunkId] + ".chunk.js";
};